import { createTimeline } from 'animejs';

export function toggleMenu() {
  const hamburger = document.querySelector('#hamburger');
  const mainMenu = document.querySelector('#main-menu');
  const overlay = document.querySelector('#menu-overlay');

  if (!hamburger || !mainMenu) return;

  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  // Ensure overlay exists (in case you prefer JS injection)
  // if (!overlay) { ... } // (omit: you already add it in HTML)

  const openMenu = () => {
    document.body.classList.add('menu-open');
    hamburger.classList.add('open');
    mainMenu.classList.add('active');
    overlay?.classList.remove('pointer-events-none');

    const tl = createTimeline({
      autoplay: false,
      defaults: { ease: 'easeInOutSine' },
    })
      .add(overlay, { opacity: [0, 1], duration: 220 }, 0)
      .add(mainMenu, { translateX: ['-100%', '0%'], duration: 320 }, 0);

    tl.play();
  };

  const closeMenu = () => {
    document.body.classList.remove('menu-open');
    hamburger.classList.remove('open');

    const tl = createTimeline({
      autoplay: false,
      defaults: { ease: 'easeInOutSine' },
    })
      .add(mainMenu, { translateX: ['0%', '-100%'], duration: 280 }, 0)
      .add(overlay, { opacity: [1, 0], duration: 220 }, 0)
      .add(mainMenu, {
        duration: 1,
        complete: () => {
          mainMenu.classList.remove('active');
          overlay?.classList.add('pointer-events-none');
        },
      });

    tl.play();
  };

  const toggle = () => {
    if (!isMobile()) return;

    const isOpen = hamburger.classList.contains('open');
    if (isOpen) closeMenu();
    else openMenu();
  };

  hamburger.addEventListener('click', (e) => {
    e.preventDefault();
    toggle();
  });

  // Click on overlay closes
  overlay?.addEventListener('click', (e) => {
    e.preventDefault();
    if (hamburger.classList.contains('open')) closeMenu();
  });

  // ESC closes
  document.addEventListener('keydown', (e) => {
    if (!isMobile()) return;
    if (e.key === 'Escape' && hamburger.classList.contains('open')) closeMenu();
  });

  // On resize to desktop: reset
  window.addEventListener('resize', () => {
    if (!isMobile()) {
      document.body.classList.remove('menu-open');
      hamburger.classList.remove('open');
      mainMenu.classList.remove('active');
      mainMenu.style.transform = '';
      overlay && (overlay.style.opacity = '');
      overlay?.classList.add('pointer-events-none');
    } else {
      // Ensure closed default off-canvas position in mobile
      if (!hamburger.classList.contains('open')) {
        mainMenu.style.transform = 'translate3d(-100%,0,0)';
      }
    }
  });
}

function measureFullHeight(el) {
  // guardo estilos inline
  const prev = {
    maxHeight: el.style.maxHeight,
    overflow: el.style.overflow,
  };

  // dejo que el contenido “tome” su alto real
  el.style.maxHeight = 'none';
  el.style.overflow = 'visible';

  // getBoundingClientRect suele ser más fiable que scrollHeight en estos casos
  const h = Math.ceil(el.getBoundingClientRect().height);

  // restauro
  el.style.maxHeight = prev.maxHeight;
  el.style.overflow = prev.overflow;

  return h;
}

function setMaxHeight(el, px) {
  el.style.maxHeight = `${px}px`;
}


(function () {
  const toggles = document.querySelectorAll('.nav-toggle');

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  // Mide el alto REAL del wrapper directo dentro de .nav-drop (tu <div> hijo)
  function getMenuHeight(menu) {
    const inner = menu?.firstElementChild; // <div> directo dentro del <ul.nav-drop>
    return inner ? inner.offsetHeight : 0;
  }

  function setFixedHeight(menu) {
    menu.style.maxHeight = getMenuHeight(menu) + 'px';
  }

  function closeItem(li) {
    const btn = li.querySelector('.nav-toggle');
    const menu = li.querySelector('.nav-drop');
    if (!btn || !menu) return;

    li.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    menu.dataset.open = 'false';

    // Congelar altura actual (correcta) para que cierre suave
    setFixedHeight(menu);
    menu.offsetHeight; // reflow

    // Animar a 0
    menu.style.maxHeight = '0px';
  }

  function openItem(li) {
    const btn = li.querySelector('.nav-toggle');
    const menu = li.querySelector('.nav-drop');
    if (!btn || !menu) return;

    li.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    menu.dataset.open = 'true';

    // Estado inicial colapsado
    menu.style.maxHeight = '0px';
    menu.offsetHeight; // reflow

    // Medir y animar a altura real
    requestAnimationFrame(() => {
      setFixedHeight(menu);
    });
  }

  function toggleItem(li) {
    if (!li) return;

    if (li.classList.contains('is-open')) {
      closeItem(li);
      return;
    }

    // Accordion: cerrar hermanos
    const siblings = Array.from(li.parentElement?.children || []).filter(n => n !== li);
    siblings.forEach(closeItem);

    openItem(li);
  }

  function refreshOpenHeights() {
    if (isDesktop()) return;
    document.querySelectorAll('.nav-main-item.is-open .nav-drop').forEach(setFixedHeight);
  }

  // Bind toggles
  toggles.forEach(btn => {
    const li = btn.closest('.nav-main-item');
    if (!li) return;

    btn.addEventListener('click', (e) => {
      if (isDesktop()) return;
      e.preventDefault();
      toggleItem(li);
    });

    btn.addEventListener('keydown', (e) => {
      if (isDesktop()) return;
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        toggleItem(li);
      }
    });
  });

  // Resize: desktop limpia inline; mobile recalcula abiertos
  window.addEventListener('resize', () => {
    if (isDesktop()) {
      document.querySelectorAll('.nav-drop').forEach(m => {
        m.style.maxHeight = '';
        m.dataset.open = 'false';
        m.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('.nav-toggle').forEach(b => b.setAttribute('aria-expanded', 'false'));
      document.querySelectorAll('.nav-main-item.is-open').forEach(li => li.classList.remove('is-open'));
    } else {
      refreshOpenHeights();
    }
  });

  // Si cambian fuentes/line-wrapping, recalculamos heights abiertos
  if (document.fonts?.ready) {
    document.fonts.ready.then(refreshOpenHeights);
  }

  // Si hay imágenes dentro, esto ayuda (opcional pero recomendable)
  window.addEventListener('load', refreshOpenHeights);

  // Escape cierra todo en mobile
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !isDesktop()) {
      document.querySelectorAll('.nav-main-item.is-open').forEach(closeItem);
    }
  });
})();


